const JIRA_COMPONENT_ANNOTATION = "jira/component";
const JIRA_BEARER_TOKEN_ANNOTATION = "jira/token-type";
const JIRA_PROJECT_KEY_ANNOTATION = "jira/project-key";
const JIRA_LABEL_ANNOTATION = "jira/label";
const JIRA_TEAM_ANNOTATION = "jira/team";
const DEFAULT_JIRA_QUERY_ANNOTATION = "jira/all-issues-jql";
const JIRA_ANNOTATION_INSTANCE_NAME = "jira/instance-name";

export { DEFAULT_JIRA_QUERY_ANNOTATION, JIRA_ANNOTATION_INSTANCE_NAME, JIRA_BEARER_TOKEN_ANNOTATION, JIRA_COMPONENT_ANNOTATION, JIRA_LABEL_ANNOTATION, JIRA_PROJECT_KEY_ANNOTATION, JIRA_TEAM_ANNOTATION };
//# sourceMappingURL=constants.esm.js.map
